import React from "react";

const Loader = ({ height = "h-10", width = "w-10", status = true }) => {
  if (!status) return null;

  return (
    <>
      <div
        className={`animate-spin rounded-full border-4 border-t-transparent border-blue-500 w-[24px] h-[24px] `}
      />
    </>
  );
};

export default Loader;
